(() => {
  const S = {
      Navy: "#0e1982",
      Clay: "#ccc0ac",
      Sage: "#bfd1a2",
      "Hunter Green": "#03513c",
      Eucalyptus: "#7a9b7f",
      "Dusty Blue": "#aebde4",
      Wine: "#810404",
      Burgundy: "#a9072b",
      Champagne: "#ece1ca",
      Terracotta: "#bf4312",
      Sangria: "#be2121",
      "Mauve Lilac": "#c77db5",
      "Nude Pink": "#edcedb",
      "Dusty Rose": "#eca2a2",
      Blush: "#fce9e9",
      White: "#ffffff",
      Ivory: "#eee6d4",
      "Soft White": "#faf8f3",
    },
    N = {
      Blush: ["8.9%", "17%"],
      "Dusty Rose": ["38.8%", "20%"],
      "Nude Pink": ["68%", "17%"],
      "Mauve Lilac": ["97.4%", "17%"],
      Sangria: ["8.9%", "42.1%"],
      Terracotta: ["38.8%", "45%"],
      Wine: ["68%", "42.1%"],
      Burgundy: ["97.4%", "42.1%"],
      White: ["8.9%", "67.6%"],
      Champagne: ["38.8%", "71%"],
      "Dusty Blue": ["68%", "67.6%"],
      Navy: ["97.4%", "67.6%"],
      Clay: ["8.9%", "93%"],
      Eucalyptus: ["38.8%", "96%"],
      "Hunter Green": ["68%", "96%"],
      Sage: ["97.4%", "96%"],
    },
    E = [
      {
        bride: "Ivory",
        bridesmaid: "Terracotta",
        shade: "Champagne",
        alternatives: ["Terracotta", "Nude Pink"],
        primary: "apex-palette-ivory-terracotta-group.png",
        secondary: "apex-palette-champagne-terracotta-detail.jpg",
        alt: "Bride and bridesmaids in coordinated getting-ready sets",
        explanation:
          "Warm champagne softens terracotta and sits naturally beside an ivory bridal look.",
      },
      {
        bride: "Soft White",
        bridesmaid: "Dusty Blue",
        shade: "Dusty Blue",
        alternatives: ["White", "Champagne"],
        primary: "apex-palette-dusty-blue-main.jpg",
        secondary: "apex-palette-blush-detail.jpg",
        alt: "Dusty blue getting-ready set in a bridal suite",
        explanation:
          "Dusty blue adds a quiet colour moment while soft white keeps the overall palette light.",
      },
      {
        bride: "Blush",
        bridesmaid: "Blush",
        shade: "Terracotta",
        alternatives: ["Dusty Rose", "Blush"],
        primary: "apex-palette-terracotta-main.jpg",
        secondary: "apex-palette-blush-main.jpg",
        alt: "Terracotta and blush pajama details",
        explanation:
          "Terracotta gives a tonal blush palette enough depth to feel intentional in photographs.",
      },
    ],
    P = {
      Ivory: [
        "Navy",
        "Clay",
        "Sage",
        "Hunter Green",
        "Eucalyptus",
        "Dusty Blue",
        "Wine",
        "Burgundy",
        "Champagne",
        "Terracotta",
        "Sangria",
        "Mauve Lilac",
        "Nude Pink",
        "Dusty Rose",
        "Blush",
        "White",
      ],
      "Soft White": [
        "Navy",
        "Dusty Blue",
        "Sage",
        "Hunter Green",
        "Eucalyptus",
        "White",
        "Champagne",
        "Clay",
        "Wine",
        "Burgundy",
      ],
      Blush: [
        "Clay",
        "Champagne",
        "Terracotta",
        "Sangria",
        "Wine",
        "Burgundy",
        "Mauve Lilac",
        "Nude Pink",
        "Dusty Rose",
      ],
      "Nude Pink": [
        "Clay",
        "Champagne",
        "Terracotta",
        "Sangria",
        "Wine",
        "Burgundy",
        "Mauve Lilac",
        "Dusty Rose",
      ],
    },
    L = (t) =>
      t
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, ""),
    D = (t, e) =>
      E.find((a) => a.bride === t && a.bridesmaid === e) || {
        bride: t,
        bridesmaid: e,
        shade: e,
        alternatives: [],
        primary: `apex-palette-${L(t)}-${L(e)}.webp`,
        secondary: "",
        alt: `Bride in ${t} with bridesmaids in ${e} getting-ready sets`,
      },
    R = [
      "Sage",
      "Eucalyptus",
      "Champagne",
      "Mauve Lilac",
      "Nude Pink",
      "Dusty Rose",
      "Blush",
      "White",
      "Clay",
      "Terracotta",
      "Dusty Blue",
      "Ivory",
      "Soft White",
    ],
    A = {},
    I = ($) => (A[$] !== void 0 ? A[$] : R.includes($)),
    F = [
      { value: "B1", sample: "Bride" },
      { value: "B10", sample: "Bride" },
      { value: "B11", sample: "Bride" },
      { value: "B16", sample: "Bride" },
      { value: "B2", sample: "Bride" },
      { value: "B21", sample: "Bride" },
      { value: "B22", sample: "Bride" },
      { value: "B4", sample: "Bride" },
      { value: "B5", sample: "Bride" },
      { value: "B7", sample: "Bride" },
      { value: "B8", sample: "Bride" },
      { value: "B9", sample: "Bride" },
      { value: "B26", sample: "B" },
    ],
    O = F.filter(({ value: t }) => t === "B5" || t === "B22"),
    T = {
      "Glitter Blush": "#e8b7bd",
      "Rose Gold": "#c98f7d",
      "Glitter Plum": "#7d4a6b",
      "Glitter White": "#f7f4ed",
      "Glitter Gold": "#d4af5a",
      "Metallic Gold": "#c8a45a",
      "Metallic Silver": "#c9c9c9",
      "Glitter Silver": "#cfcfcf",
      "Solid Black": "#171717",
      "Solid White": "#ffffff",
    };
  class M extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      ((this.initialized = !0),
        (this.variants = this.readJson("[data-product-variants]") || []),
        (this.options = this.readJson("[data-product-options]") || {
          sizes: [],
          colors: [],
        }),
        (this.options.sizes = this.options.sizes || []),
        (this.options.colors = this.options.colors || []),
        (this.connectedShades = this.readJson("[data-connected-shades]") || {}),
        Object.keys(this.connectedShades).length &&
          (this.options.colors = Object.keys(this.connectedShades)),
        (this.sizeIndex = Number.isInteger(this.options.sizeIndex)
          ? this.options.sizeIndex
          : 0),
        (this.colorIndex = Number.isInteger(this.options.colorIndex)
          ? this.options.colorIndex
          : 1),
        (this.sizeName = this.options.sizeName || "Size"),
        (this.colorName = this.options.colorName || "Shade"));
      const t = this.readJson("[data-shade-map]") || {};
      (Object.entries(t).forEach(([e, a]) => {
        (a && a.hex && (S[e] = a.hex),
          a && typeof a.light == "boolean" && (A[e] = a.light));
      }),
        (this.shadeImages = this.readJson("[data-shade-images]") || {}),
        this.applyConnectedSwatches(),
        (this.threadImages = this.readJson("[data-thread-images]") || {}),
        (this.openPopup = null),
        (this.shadeChart = this.readJson("[data-shade-chart]") || ""),
        (this.satinTexture = this.readJson("[data-satin-texture]") || ""),
        (this.personalization = this.readJson(
          "[data-personalization-config]",
        ) || {
          mode: "preview",
          prices: { Front: 800, Back: 1300, Both: 2e3 },
          variantIds: {},
        }),
        (this.personalization.choices = this.personalization.choices || [
          { key: "Front", label: "Front", fields: ["frontInitial"], price: Number(this.personalization.prices?.Front || 0), variantId: this.personalization.variantIds?.Front },
          { key: "Back", label: "Back", fields: ["backText"], price: Number(this.personalization.prices?.Back || 0), variantId: this.personalization.variantIds?.Back },
          { key: "Both", label: "Both", fields: ["frontInitial", "backText"], price: Number(this.personalization.prices?.Both || 0), variantId: this.personalization.variantIds?.Both },
        ]),
        (this.personalization.fonts = this.personalization.fonts || F.map(({ value }) => value)),
        (this.personalization.frontFonts = this.personalization.frontFonts || O.map(({ value }) => value)),
        (this.personalization.threadColors = this.personalization.threadColors || Object.keys(T)),
        (this.personalization.fieldDefinitions = this.personalization.fieldDefinitions || (this.personalization.profile === "everyday_cloud" ? {
          frontInitial: { label: "Front Initial", limit: 2, placeholder: "Initials" },
          frontName: { label: "Front Name", limit: 20, placeholder: "Name" },
          backText: { label: "Back Text", limit: 30, placeholder: "Bride" },
        } : {})),
        (this.savedCalibration = this.readJson("[data-saved-personalization-calibration]")),
        this.savedCalibration?.fieldDefinitions && (this.personalization.fieldDefinitions = Object.fromEntries(Object.entries(this.personalization.fieldDefinitions).map(([key, value]) => [key, { ...value, ...(this.savedCalibration.fieldDefinitions[key] || {}) }]))),
        (this.personalizationPreviewImages = this.readJson(
          "[data-personalization-preview-images]",
        ) || {}),
        (this.productAssignment = this.resolveProductAssignment()),
        (this.personalization.enabled = Boolean(this.productAssignment?.enabled && this.productAssignment.profileId === this.personalization.profile)),
        this.productAssignment && (this.dataset.styleName = this.productAssignment.styleName),
        (this.personalizationEditorId = null),
        (this.threshold = Number(this.dataset.freeShippingThreshold || 7500)),
        (this.moneyFormat = this.dataset.moneyFormat || "${{amount}}"),
        (this.rowsHost = this.querySelector("[data-builder-rows]")),
        (this.error = this.querySelector("[data-builder-error]")),
        (this.selectedPrice = this.querySelector("[data-selected-variant-price]")),
        (this.selectedComparePrice = this.querySelector("[data-selected-variant-compare-price]")),
        (this.addButton = this.querySelector("[data-add-group]")),
        (this.addLabel = this.querySelector("[data-add-group-label]")),
        (this.sticky = this.querySelector("[data-sticky-cta]")),
        (this.stickyButton = this.querySelector("[data-sticky-action]")),
        (this.stickyColor = this.querySelector("[data-sticky-color]")),
        (this.stickySize = this.querySelector("[data-sticky-size]")),
        this.querySelectorAll("[data-sticky-color-choice]").forEach((e) => {
          const a = S[e.dataset.stickyColorChoice],
            img = this.shadeImages[e.dataset.stickyColorChoice],
            holder = e.querySelector(".lsp__swatch-item-image");
          a && (e.style.setProperty("--lsp-swatch", a), (e.dataset.swatch = a));
          img && holder && (holder.innerHTML = `<img src="${this.escape(img)}" alt="" loading="lazy">`);
        }),
        (this.partyRows = [this.makeRow()]),
        (this.activeId = this.partyRows[0].id),
        this.bindEvents(),
        this.render(),
        this.setupGalleryCarousel(),
        this.setupSticky(),
        this.setupShadeRequests(),
        this.renderDeliveryEstimate());
    }
    // Estimated delivery date. Computed in the visitor's own timezone rather
    // than server-side, so it always reflects "today" as they see it.
    renderDeliveryEstimate() {
      const el = this.querySelector("[data-delivery-tab-date]");
      if (!el) return;
      const days = Number(this.dataset.eddDays);
      if (!Number.isFinite(days) || days <= 0) {
        this.querySelector("[data-delivery-tab]")?.setAttribute("hidden", "");
        return;
      }
      const MONTHS = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sept", "Oct", "Nov", "Dec",
      ];
      const target = new Date();
      target.setDate(target.getDate() + days);
      const weekday = new Intl.DateTimeFormat(undefined, { weekday: "long" }).format(target);
      el.textContent = `${weekday}, ${MONTHS[target.getMonth()]} ${target.getDate()}`;
    }
    setupGalleryCarousel() {
      const rail = this.querySelector("[data-gallery-thumbs-rail]"),
        next = this.querySelector("[data-gallery-thumbs-next]");
      if (!rail || !next) return;
      const update = () => {
        const canScroll = rail.scrollHeight > rail.clientHeight + 1,
          isAtEnd = rail.scrollTop + rail.clientHeight >= rail.scrollHeight - 2;
        next.hidden = !canScroll || isAtEnd;
      };
      next.addEventListener("click", () => {
        rail.scrollBy({ top: Math.max(rail.clientHeight - 85, 85), behavior: "smooth" });
      });
      rail.addEventListener("scroll", update, { passive: !0 });
      window.addEventListener("resize", update, { passive: !0 });
      requestAnimationFrame(update);
    }
    // Native Shopify swatches from the colour product group take priority:
    // swatch image > swatch colour > custom.shade_map > featured image > neutral.
    applyConnectedSwatches() {
      const isLight = (hex) => {
        const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
        if (!m) return false;
        const n = parseInt(m[1], 16);
        return (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255 > 0.8;
      };
      Object.entries(this.connectedShades || {}).forEach(([name, shade]) => {
        if (!shade) return;
        if (shade.swatchColor) ((S[name] = shade.swatchColor), (A[name] = isLight(shade.swatchColor)));
        if (shade.swatchImage) this.shadeImages[name] = shade.swatchImage;
        else if (!shade.swatchColor && !S[name] && !this.shadeImages[name] && shade.featuredImage)
          this.shadeImages[name] = shade.featuredImage;
      });
    }
    resolveProductAssignment() {
      // Duplicated colour listings get new product IDs that are not in the generated
      // assignment map yet; inherit the assignment of a sibling in the same colour group.
      const map = window.BlossomPersonalizationAssignments || {};
      const own = map[String(this.dataset.productId)];
      if (own) return own;
      for (const shade of Object.values(this.connectedShades || {})) {
        const id = String(shade?.productId || "").split("/").pop();
        if (id && map[id]?.enabled) return map[id];
      }
      return null;
    }
    readJson(t) {
      try {
        return JSON.parse(this.querySelector(t)?.textContent || "null");
      } catch {
        return null;
      }
    }
    defaultSelection() {
      const t = this.variants.find((e) => e.available) || this.variants[0];
      let requestedSize = new URLSearchParams(window.location.search).get("lsp_size");
      try {
        requestedSize ||= window.sessionStorage.getItem("lsp_connected_size");
        window.sessionStorage.removeItem("lsp_connected_size");
      } catch {}
      return {
        size:
          (requestedSize && this.options.sizes.includes(requestedSize)
            ? requestedSize
            : null) ||
          (t && this.sizeOf(t)) ||
          this.options.sizes[0] ||
          "",
        color: (t && this.colorOf(t)) || this.options.colors[0] || "",
      };
    }
    navigateToConnectedShade(connectedShade, size) {
      if (!connectedShade?.url || connectedShade.current) return !1;
      try {
        if (size) window.sessionStorage.setItem("lsp_connected_size", size);
        else window.sessionStorage.removeItem("lsp_connected_size");
      } catch {}
      window.location.assign(new URL(connectedShade.url, window.location.origin).href);
      return !0;
    }
    makeRow(t = null) {
      const e = this.defaultSelection();
      return {
        id: `set-${Date.now()}-${Math.random().toString(16).slice(2)}`,
        size: t?.size || e.size,
        color: t?.color || e.color,
        quantity: 1,
        personalize: !1,
        placement: this.personalization.choices[0]?.key || "Front",
        frontInitial: "",
        bottomText: "",
        beltText: "",
        frontName: "",
        pocketInitials: "",
        abovePocketName: "",
        frontText: "",
        backText: "",
        frontFont: t?.frontFont || this.personalization.defaultFrontFont || "B26",
        backFont: t?.backFont || t?.font || this.personalization.defaultBackFont || "B9",
        threadColor: this.personalization.threadColors.includes("Metallic Gold") ? "Metallic Gold" : this.personalization.threadColors[0],
        approval: null,
      };
    }
    personalizationChoice(t) {
      return this.personalization.choices.find((e) => e.key === t.placement) || this.personalization.choices[0];
    }
    personalizationFields(t) {
      return this.personalizationChoice(t)?.fields || [];
    }
    personalizationFieldValue(t, key) {
      if (key === "frontInitial") return t.frontInitial;
      if (key === "bottomText") return t.bottomText || t.frontName;
      if (key === "beltText") return t.beltText || t.frontName;
      if (key === "pocketInitials") return t.pocketInitials;
      if (key === "frontName") return t.frontName;
      if (key === "abovePocketName") return t.abovePocketName;
      return t.backText;
    }
    personalizationFieldDefinition(key) {
      const defaults = {
        frontInitial: { label: "Front Initial", limit: 1, placeholder: "Initials" },
        bottomText: { label: "Bottom text", limit: 30, placeholder: "Bride" },
        beltText: { label: "Belt text", limit: 25, placeholder: "Bride" },
        frontName: { label: "Front Name", limit: 20, placeholder: "Name" },
        pocketInitials: { label: "Pocket initials", limit: 2, placeholder: "AB" },
        abovePocketName: { label: "Above pocket name", limit: 30, placeholder: "Bride" },
        backText: { label: "Back Text", limit: 30, placeholder: "Bride" },
      };
      return { ...defaults[key], ...(this.personalization.fieldDefinitions?.[key] || {}) };
    }
    normalizedField(t, key) {
      const value = this.personalizationFieldValue(t, key).normalize("NFC").trim();
      return key === "frontInitial" || key === "pocketInitials" ? value.toUpperCase() : value;
    }
    graphemes(value) {
      const normalized = String(value || "").normalize("NFC");
      if (typeof Intl !== "undefined" && Intl.Segmenter) return [...new Intl.Segmenter(undefined, { granularity: "grapheme" }).segment(normalized)].map((part) => part.segment);
      return Array.from(normalized);
    }
    wrappedTextLayout(text, font, preferredSize, minimumSize, maxWidth, maxLines = 2) {
      const canvas = document.createElement("canvas"), ctx = canvas.getContext("2d"), value = String(text || "").normalize("NFC").trim();
      const graphemes = input => this.graphemes(input);
      const linesFor = size => {
        ctx.font = `${size}px "LSP ${font}"`;
        if (!value) return [""];
        const lines = [], words = value.split(/\s+/).filter(Boolean); let line = "";
        const pushWord = word => {
          if (ctx.measureText(word).width <= maxWidth) { line = word; return; }
          let fragment = "";
          for (const character of graphemes(word)) {
            const candidate = fragment + character;
            if (fragment && ctx.measureText(candidate).width > maxWidth) { lines.push(fragment); fragment = character; }
            else fragment = candidate;
          }
          line = fragment;
        };
        for (const word of words) {
          if (!line) { pushWord(word); continue; }
          if (ctx.measureText(`${line} ${word}`).width <= maxWidth) { line += ` ${word}`; continue; }
          lines.push(line); line = ""; pushWord(word);
        }
        if (line) lines.push(line);
        return lines;
      };
      for (let size = Number(preferredSize); size >= Number(minimumSize); size -= 1) {
        const lines = linesFor(size);
        if (lines.length <= maxLines) return { lines, size, lineHeight: size * 1.15, fits: true };
      }
      const size = Number(minimumSize), lines = linesFor(size);
      return { lines, size, lineHeight: size * 1.15, fits: false };
    }
    personalizationMaxLines(fieldKey) {
      return fieldKey === "backText" ? 2 : 1;
    }
    fieldError(t, key) {
      const definition = this.personalizationFieldDefinition(key), raw = this.personalizationFieldValue(t, key), normalized = this.normalizedField(t, key);
      if (!normalized) return `Enter the ${definition.label.toLowerCase()}.`;
      if (/\r|\n/.test(raw)) return "Line breaks are not supported.";
      if (this.graphemes(normalized).length > Number(definition.limit)) return `${definition.label} can contain up to ${definition.limit} ${Number(definition.limit) === 1 ? "character" : "characters"}.`;
      if ((key === "frontInitial" || key === "pocketInitials") && !/^[A-Z]+$/.test(normalized)) return "Initials must contain only A–Z letters.";
      return "";
    }
    personalizationSnapshot(t) {
      const fields = {};
      this.personalizationFields(t).forEach((key) => { fields[key] = this.normalizedField(t, key); });
      return { style: this.dataset.styleName, profile: this.personalization.profile, version: this.personalization.version || 1, variantId: this.selectedVariant(t)?.id, size: t.size, color: t.color, placement: t.placement, fields, frontFont: t.frontFont, backFont: t.backFont, threadColor: t.threadColor };
    }
    fingerprint(t) {
      const value = JSON.stringify(this.personalizationSnapshot(t)); let hash = 2166136261;
      for (let i = 0; i < value.length; i += 1) { hash ^= value.charCodeAt(i); hash = Math.imul(hash, 16777619); }
      return `fnv1a-${(hash >>> 0).toString(16).padStart(8, "0")}`;
    }
    invalidateApproval(t) {
      if (t?.approval?.url) URL.revokeObjectURL(t.approval.url);
      if (!t) return;
      t.approval = null;
      const reviewActions = this.querySelector(`[data-row-id="${t.id}"] .lsp__approval-actions`);
      if (reviewActions) reviewActions.innerHTML = '<button type="button" data-personalization-review>Continue to review</button>';
      reviewActions?.closest("[data-personalization-editor]")?.classList.remove("is-reviewing");
    }
    // Two-step editor: bring the top of the current step into view after switching.
    showPersonalizationStep() {
      const dialog = this.querySelector("[data-personalization-editor][open]");
      if (!dialog) return;
      const toTop = () => { dialog.scrollTop = 0; dialog.querySelectorAll(".lsp__personalization-form, .lsp__personalization-preview").forEach((panel) => { panel.scrollTop = 0; }); };
      dialog.querySelector("[data-personalization-step-heading]")?.focus({ preventScroll: true });
      toTop();
      // showModal() and the proof image can shift scroll after this frame.
      requestAnimationFrame(() => requestAnimationFrame(toTop));
    }
    async loadProofImage(url) {
      return new Promise((resolve, reject) => { const image = new Image(); image.crossOrigin = "anonymous";
        const timeout = setTimeout(() => reject(new Error("The placement photograph took too long to load. Please retry.")), 20000);
        image.addEventListener("load", () => clearTimeout(timeout), { once: true });
        image.addEventListener("error", () => clearTimeout(timeout), { once: true }); image.onload = () => resolve(image); image.onerror = () => reject(new Error("The placement photograph could not be loaded.")); image.src = url; });
    }
    activePreviewScenes(t) {
      const grouped = new Map();
      for (const key of this.personalizationFields(t)) {
        const definition = this.personalizationFieldDefinition(key), view = definition.view || (key === "backText" ? "back" : "front");
        if (!grouped.has(view)) grouped.set(view, []);
        grouped.get(view).push({ key, definition, text: this.normalizedField(t, key), font: definition.fontTarget === "back" ? t.backFont : t.frontFont });
      }
      return [...grouped.entries()].map(([key, fields]) => ({ key, label: fields.length === 1 && fields[0].definition.placement === "Belt" ? "Belt" : key === "back" ? "Back" : "Front", image: this.personalizationPreviewImages[key], dimensions: this.personalization.views?.[key] || { width: 681, height: 1148 }, fields }));
    }
    async loadProofFont(font, text = "Bride") {
      let timer;
      try {
        const faces = await Promise.race([
          document.fonts.load(`64px "LSP ${font}"`, text),
          new Promise((_, reject) => { timer = setTimeout(() => reject(new Error(`Font ${font} took too long to load. Please retry.`)), 20000); }),
        ]);
        if (!faces.length || faces.some(face => face.status !== "loaded")) throw new Error(`Exact font ${font} could not be loaded. Please retry.`);
      } finally { clearTimeout(timer); }
    }
    async createApprovedProof(t) {
      const snapshot = this.personalizationSnapshot(t), fingerprint = this.fingerprint(t), scenes = this.activePreviewScenes(t), choiceLabel = this.personalizationChoice(t).label;
      const fonts = [...new Set(scenes.flatMap(scene => scene.fields.map(field => field.font)))];
      await Promise.all(fonts.map(font => this.loadProofFont(font)));
      fonts.forEach(font => { if (!document.fonts.check(`64px "LSP ${font}"`)) throw new Error(`Exact font ${font} could not be loaded.`); });
      const images = await Promise.all(scenes.map(scene => this.loadProofImage(scene.image)));
      const panelWidth = scenes.length > 1 ? 820 : 900, gap = 34, width = scenes.length > 1 ? panelWidth * scenes.length + gap * (scenes.length - 1) + 100 : 1000;
      const imageHeights = scenes.map(scene => Math.round(panelWidth * scene.dimensions.height / scene.dimensions.width));
      const imageHeight = Math.max(...imageHeights), header = 180, footer = 280;
      const canvas = document.createElement("canvas"); canvas.width = width; canvas.height = header + imageHeight + footer;
      const ctx = canvas.getContext("2d"); ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, width, canvas.height); ctx.fillStyle = "#171717"; ctx.textAlign = "center";
      ctx.font = "700 46px Arial"; ctx.fillText(snapshot.style, width / 2, 64); ctx.font = "28px Arial"; ctx.fillText(`${snapshot.size} · ${snapshot.color} · ${choiceLabel}`, width / 2, 112); ctx.font = "22px Arial"; ctx.fillText("Placement proof. Garment and lettering colours are listed below.", width / 2, 151);
      scenes.forEach((scene, index) => {
        const x0 = 50 + index * (panelWidth + gap), h = imageHeights[index], y0 = header;
        ctx.drawImage(images[index], x0, y0, panelWidth, h);
        scene.fields.forEach(field => { const d = field.definition, scale = panelWidth / Number(scene.dimensions.width), maxLines = this.personalizationMaxLines(field.key), layout = this.wrappedTextLayout(field.text, field.font, Number(d.preferredFontSize || (maxLines === 1 ? 96 : 78)) * scale, Number(d.minimumFontSize || 30) * scale, panelWidth * Number(d.maxWidth || 60) / 100, maxLines); if (!layout.fits) throw new Error(`This name does not fit the available area in ${field.font}. Please shorten it.`); ctx.font = `${layout.size}px "LSP ${field.font}"`; ctx.save(); ctx.translate(x0 + panelWidth * Number(d.x || 50) / 100, y0 + h * Number(d.y || 30) / 100); ctx.rotate(Number(d.rotationDeg || 0) * Math.PI / 180); ctx.textBaseline = "middle"; ctx.fillStyle = "#171717"; layout.lines.forEach((line, lineIndex) => ctx.fillText(line, 0, (lineIndex - (layout.lines.length - 1) / 2) * layout.lineHeight)); ctx.restore(); });
        ctx.font = "700 23px Arial"; ctx.fillText(scene.label, x0 + panelWidth / 2, y0 + h + 42);
      });
      ctx.font = "22px Arial"; const specs = scenes.flatMap(scene => scene.fields.map(field => `${field.definition.label}: “${field.text}” · ${field.font}`)).join("     "); ctx.fillText(specs, width / 2, header + imageHeight + 105); ctx.fillText(`Lettering colour: ${snapshot.threadColor}`, width / 2, header + imageHeight + 148);
      const proofId = crypto.randomUUID(); ctx.font = "20px Arial"; ctx.fillStyle = "#5d5d5d"; ctx.fillText(`Proof ${proofId}`, width / 2, header + imageHeight + 210);
      const blob = await new Promise((resolve, reject) => canvas.toBlob(value => value ? resolve(value) : reject(new Error("Preview export failed.")), "image/png"));
      if (blob.size > 4 * 1024 * 1024) throw new Error("The approved preview exceeds the upload limit.");
      return { blob, proofId, url: URL.createObjectURL(blob), fingerprint, status: "review", snapshot };
    }
    async reviewPersonalization(t) {
      const error = this.validationFor(t, false); if (error) return this.showError(error);
      try { this.setLoading(true); this.clearError(); this.invalidateApproval(t); const proof = await this.createApprovedProof(t);
        if (this.getRow(t.id) !== t || proof.fingerprint !== this.fingerprint(t) || this.personalizationEditorId !== t.id) {
          URL.revokeObjectURL(proof.url);
          throw new Error("Your selection changed while preparing the proof. Review your personalization again.");
        }
        t.approval = proof; this.render(); this.showPersonalizationStep(); }
      catch (error) { this.showError(error.message || "The preview could not be prepared."); }
      finally { this.setLoading(false); }
    }
    bindEvents() {
      (this.addEventListener("click", (t) => this.onClick(t)),
        this.addEventListener("keydown", (t) => {
          if (t.key !== "Escape" || !this.openPopup) return;
          const [e, a] = this.openPopup.split("|");
          ((this.openPopup = null),
            this.render(),
            this.querySelector(
              `[data-row-id="${e}"] [data-popup-toggle="${a}"]`,
            )?.focus());
        }),
        this.addEventListener("change", (t) => this.onChange(t)),
        this.addEventListener("input", (t) => this.onInput(t)),
        this.addEventListener(
          "close",
          (t) => {
            if (t.target.matches("[data-personalization-editor]")) {
              const e = t.target.closest("[data-row-id]")?.dataset.rowId;
              this.personalizationEditorId = null;
              if (this.cancelIncompletePersonalization(e)) return;
              this.personalizationEditorTrigger?.focus();
              this.personalizationEditorTrigger = null;
            }
          },
          !0,
        ),
        this.addButton.addEventListener("click", () => this.addToCart()),
        this.stickyButton.addEventListener("click", () =>
          this.handleStickyAction(),
        ),
        this.sticky.addEventListener("keydown", (t) => {
          const e = t.target.closest("[data-sticky-color-choice]");
          if (!e) return;
          const a = [
              ...this.querySelectorAll(
                "[data-sticky-color-choice]:not(:disabled)",
              ),
            ],
            s = a.indexOf(e);
          if (t.key === "ArrowDown" || t.key === "ArrowUp")
            (t.preventDefault(),
              a[
                (s + (t.key === "ArrowDown" ? 1 : -1) + a.length) % a.length
              ].focus());
          else if (t.key === "Escape") {
            (t.preventDefault(),
              (this.querySelector("[data-sticky-color-menu]").hidden = !0));
            const i = this.querySelector("[data-sticky-color-trigger]");
            (i.setAttribute("aria-expanded", "false"), i.focus());
          }
        }),
        this.querySelectorAll("[data-gallery-thumb]").forEach((t) =>
          t.addEventListener("click", () => this.setGallery(t)),
        ),
        this.querySelector("[data-size-dialog]")?.addEventListener(
          "close",
          () => {
            (this.sizeGuideTrigger?.focus(), (this.sizeGuideTrigger = null));
          },
        ),
        this.querySelector("[data-personalization-dialog]")?.addEventListener(
          "close",
          () => {
            (this.personalizationGuideTrigger?.focus(),
              (this.personalizationGuideTrigger = null));
          },
        ));
    }
    closeOpenPopup(t = !1) {
      if (!this.openPopup) return;
      const [e, a] = this.openPopup.split("|"),
        s = this.querySelector(`[data-row-id="${e}"]`),
        i = s?.querySelector(`[data-popup-toggle="${a}"]`),
        r = s?.querySelector(`[data-popup="${a}"]`),
        c = s?.querySelector(`[data-popup-close="${a}"].lsp__swatch-popup-bg`);
      ((this.openPopup = null),
        i?.setAttribute("aria-expanded", "false"),
        i?.closest(".lsp__swatches")?.classList.remove("is-open"));
      r && (r.hidden = !0);
      c && (c.hidden = !0);
      t && i?.focus();
    }
    onClick(t) {
      const o = t.target.closest("[data-popup-toggle]");
      if (
        this.openPopup &&
        !t.target.closest("[data-popup]") &&
        !o
      ) {
        const e = t.target.matches("[data-personalization-editor]");
        this.closeOpenPopup();
        if (e) return;
      }
      const e = t.target.closest("[data-sticky-color-trigger]");
      if (e) {
        const l = this.querySelector("[data-sticky-color-menu]"),
          u = l.hidden;
        ((l.hidden = !u),
          e.setAttribute("aria-expanded", String(u)),
          u &&
            (
              l.querySelector('[aria-selected="true"]') ||
              l.querySelector("button")
            )?.focus());
        return;
      }
      const a = t.target.closest("[data-sticky-color-choice]");
      if (a) {
        ((this.stickyColor.value = a.dataset.stickyColorChoice),
          this.stickyColor.dispatchEvent(new Event("change", { bubbles: !0 })),
          (this.querySelector("[data-sticky-color-menu]").hidden = !0),
          this.querySelector("[data-sticky-color-trigger]").setAttribute(
            "aria-expanded",
            "false",
          ));
        return;
      }
      const s = t.target.closest("[data-sticky-size-trigger]");
      if (s) {
        const l = this.querySelector("[data-sticky-size-menu]"),
          u = l.hidden;
        ((l.hidden = !u),
          s.setAttribute("aria-expanded", String(u)),
          u &&
            (
              l.querySelector('[aria-selected="true"]') ||
              l.querySelector("button")
            )?.focus());
        return;
      }
      const i = t.target.closest("[data-sticky-size-choice]");
      if (i) {
        ((this.stickySize.value = i.dataset.stickySizeChoice),
          this.stickySize.dispatchEvent(new Event("change", { bubbles: !0 })),
          (this.querySelector("[data-sticky-size-menu]").hidden = !0),
          this.querySelector("[data-sticky-size-trigger]").setAttribute(
            "aria-expanded",
            "false",
          ));
        return;
      }
      const r = t.target.closest("[data-size-guide-open]");
      if (r) {
        ((this.sizeGuideTrigger = r),
          this.querySelector("[data-size-dialog]")?.showModal(),
          this.track("size_guide_opened"));
        return;
      }
      if (t.target.closest("[data-size-guide-close]")) {
        this.querySelector("[data-size-dialog]")?.close();
        return;
      }
      if (t.target.matches("[data-size-dialog]")) {
        t.target.close();
        return;
      }
      const c = t.target.closest("[data-personalization-guide-open]");
      if (c) {
        ((this.personalizationGuideTrigger = c),
          this.querySelector("[data-personalization-dialog]")?.showModal(),
          this.track("personalization_guide_opened"));
        return;
      }
      if (t.target.closest("[data-personalization-guide-close]")) {
        this.querySelector("[data-personalization-dialog]")?.close();
        return;
      }
      if (t.target.matches("[data-personalization-dialog]")) {
        t.target.close();
        return;
      }
      const P = t.target.closest("[data-personalization-editor-open]");
      if (P) {
        ((this.personalizationEditorId = P.closest("[data-row-id]")?.dataset.rowId),
          (this.personalizationEditorTrigger = P),
          this.render());
        return;
      }
      const E = t.target.closest("[data-personalization-editor-close]");
      if (E) {
        this.personalizationEditorId = null;
        E.closest("[data-personalization-editor]")?.close();
        return;
      }
      if (t.target.matches("[data-personalization-editor]")) {
        this.personalizationEditorId = null;
        t.target.close();
        return;
      }
      const review = t.target.closest("[data-personalization-review]");
      if (review) { const row = this.getRow(review.closest("[data-row-id]")?.dataset.rowId); if (row) this.reviewPersonalization(row); return; }
      const editDetails = t.target.closest("[data-personalization-edit]");
      if (editDetails) { const row = this.getRow(editDetails.closest("[data-row-id]")?.dataset.rowId); if (row) { this.clearError(); this.invalidateApproval(row); this.render(); this.showPersonalizationStep(); } return; }
      const approve = t.target.closest("[data-personalization-approve]");
      if (approve) { const row = this.getRow(approve.closest("[data-row-id]")?.dataset.rowId); if (row?.approval?.status === "review" && row.approval.fingerprint === this.fingerprint(row)) { row.approval.status = "approved"; row.approval.approvedAt = new Date().toISOString(); this.personalizationEditorId = null; this.render(); } return; }
      const h = o;
      if (h) {
        const l = h.closest("[data-row-id]")?.dataset.rowId,
          u = h.dataset.popupToggle,
          k = `${l}|${u}`;
        if (
          ((this.openPopup = this.openPopup === k ? null : k),
          this.render(),
          this.openPopup)
        ) {
          const C = this.querySelector(
            `[data-row-id="${l}"] [data-popup="${u}"]`,
          );
          (
            C?.querySelector("button.lsp__swatch-item.is-selected") ||
            C?.querySelector(".lsp__swatch-item.is-selected input") ||
            C?.querySelector("button.lsp__swatch-item") ||
            C?.querySelector("input:not([disabled])")
          )?.focus();
        } else
          this.querySelector(
            `[data-row-id="${l}"] [data-popup-toggle="${u}"]`,
          )?.focus();
        return;
      }
      const p = t.target.closest("[data-popup-close]");
      if (p) {
        const l = p.closest("[data-row-id]")?.dataset.rowId,
          u = p.dataset.popupClose;
        ((this.openPopup = null),
          this.render(),
          this.querySelector(
            `[data-row-id="${l}"] [data-popup-toggle="${u}"]`,
          )?.focus());
        return;
      }
      const d = t.target.closest(".lsp__personalize-control");
      if (d && !t.target.closest(".lsp__toggle")) {
        d.querySelector("[data-personalize]")?.click();
        return;
      }
      const n = t.target.closest(
        "[data-size], [data-color], [data-quantity-choice], [data-placement], [data-font-choice], [data-thread-color]",
      );
      if (n) {
        const l = this.getRow(n.closest("[data-row-id]")?.dataset.rowId);
        if (!l || n.disabled) return;
        const u = n.matches("[data-color]");
        if (u) {
          const connectedShade = this.connectedShades[n.value];
          if (this.navigateToConnectedShade(connectedShade, l.size)) return;
        }
        const changesDesign = !n.matches("[data-quantity-choice]");
        if (changesDesign) this.invalidateApproval(l);
        (n.matches("[data-size]") &&
          ((l.size = n.value),
          (this.openPopup = null),
          this.track("size_selected", { size: l.size })),
          n.matches("[data-quantity-choice]") &&
            ((l.quantity = Math.max(1, Math.min(10, Number(n.value) || 1))),
            (this.openPopup = null),
            this.track("quantity_changed", { quantity: l.quantity })),
          u &&
            ((l.color = n.value),
            (this.openPopup = null),
            this.track("shade_selected", { shade: l.color })),
          n.matches("[data-placement]") &&
            ((l.placement = n.value),
            (this.openPopup = null),
            this.track("personalization_placement_selected", {
              placement: l.placement,
            })),
          n.matches("[data-font-choice]") &&
            ((l[n.dataset.fontTarget === "front" ? "frontFont" : "backFont"] = n.value),
            this.personalization.sharedFont && ((l.frontFont = n.value), (l.backFont = n.value)),
            (this.openPopup = null),
            this.track("personalization_font_selected", {
              placement: n.dataset.fontTarget,
              font: n.value,
            })),
          n.matches("[data-thread-color]") &&
            ((l.threadColor = n.value),
            (this.openPopup = null),
            this.track("personalization_thread_selected", {
              thread: l.threadColor,
            })),
          this.clearError(),
          this.render(),
          u && requestAnimationFrame(() => this.revealSelectedShade(l.id)));
        return;
      }
      const g = t.target.closest("[data-quantity-action]");
      if (g) {
        const l = this.getRow(g.closest("[data-row-id]")?.dataset.rowId);
        if (!l) return;
        const u = g.dataset.quantityAction === "increase" ? 1 : -1;
        ((l.quantity = Math.max(1, Math.min(10, l.quantity + u))),
          this.track("quantity_changed", { quantity: l.quantity }),
          this.clearError(),
          this.render());
        return;
      }
      const v = t.target.closest("[data-row-action]");
      if (!v) return;
      const m = this.getRow(v.closest("[data-row-id]")?.dataset.rowId);
      if (!m) return;
      const w = v.dataset.rowAction;
      if (
        (w === "edit" && ((this.activeId = m.id), this.render()),
        w === "duplicate" && this.addRow(m),
        w === "remove")
      ) {
        if (this.partyRows.length === 1) return;
        ((this.partyRows = this.partyRows.filter((l) => l.id !== m.id)),
          (this.activeId = this.partyRows[0]?.id),
          this.render());
      }
    }
    onChange(t) {
      // Preserve the clicked control when a text field commits on blur.
      if (t.target.matches("[data-front-initial], [data-front-name], [data-bottom-text], [data-belt-text], [data-pocket-initials], [data-above-pocket-name], [data-back-text]")) return;
      const e = t.target;
      if (e.matches("[data-sticky-color], [data-sticky-size]")) {
        const s = this.partyRows[0];
        (e.matches("[data-sticky-color]")
          ? ((s.color = e.value),
            s.size && !this.selectedVariant(s)?.available && (s.size = ""),
            this.track("shade_selected", {
              shade: s.color,
              source: "sticky_cart",
            }))
          : ((s.size = e.value),
            s.color && !this.selectedVariant(s)?.available && (s.color = ""),
            this.track("size_selected", {
              size: s.size,
              source: "sticky_cart",
            })),
          this.clearError(),
          this.render());
        return;
      }
      const a = this.getRow(e.closest("[data-row-id]")?.dataset.rowId);
      if (a && e.matches("[data-color]")) {
        const connectedShade = this.connectedShades[e.value];
        if (this.navigateToConnectedShade(connectedShade, a.size)) return;
      }
      a &&
        (e.matches("[data-size], [data-color], [data-personalize]") && this.invalidateApproval(a),
        e.matches("[data-size]") && (a.size = e.value),
        e.matches("[data-color]") && (a.color = e.value),
        e.matches("[data-personalize]") &&
          ((a.personalize = e.checked),
          (this.personalizationEditorId = e.checked ? a.id : null),
          this.track("personalization_toggled", { enabled: a.personalize })),
        this.clearError(),
        this.render());
    }
    onInput(t) {
      const e = t.target,
        a = this.getRow(e.closest("[data-row-id]")?.dataset.rowId);
      if (!a) return;
      const s = e.matches("[data-front-initial], [data-bottom-text], [data-belt-text], [data-front-name], [data-pocket-initials], [data-above-pocket-name], [data-front-text], [data-back-text]");
      if (s) this.invalidateApproval(a);
      if (s) {
        const fieldKey = e.matches("[data-front-initial]") ? "frontInitial" : e.matches("[data-bottom-text]") ? "bottomText" : e.matches("[data-belt-text]") ? "beltText" : e.matches("[data-front-name]") ? "frontName" : e.matches("[data-pocket-initials]") ? "pocketInitials" : e.matches("[data-above-pocket-name]") ? "abovePocketName" : "backText";
        const definition = this.personalizationFieldDefinition(fieldKey), characters = this.graphemes(e.value.normalize("NFC"));
        if (characters.length > Number(definition.limit)) e.value = characters.slice(0, Number(definition.limit)).join("");
      }
      (e.matches("[data-front-initial]") && (a.frontInitial = e.value),
        e.matches("[data-bottom-text]") && (a.bottomText = e.value),
        e.matches("[data-belt-text]") && (a.beltText = e.value),
        e.matches("[data-front-name]") && (a.frontName = e.value),
        e.matches("[data-pocket-initials]") && (a.pocketInitials = e.value),
        e.matches("[data-above-pocket-name]") && (a.abovePocketName = e.value),
        e.matches("[data-front-text]") && (a.frontText = e.value),
        e.matches("[data-back-text]") && (a.backText = e.value));
      if (s) {
        const fieldKey = e.matches("[data-front-initial]") ? "frontInitial" : e.matches("[data-bottom-text]") ? "bottomText" : e.matches("[data-belt-text]") ? "beltText" : e.matches("[data-front-name]") ? "frontName" : e.matches("[data-pocket-initials]") ? "pocketInitials" : e.matches("[data-above-pocket-name]") ? "abovePocketName" : "backText",
          message = this.fieldError(a, fieldKey), i = Boolean(message),
          r = e.parentElement?.querySelector("[data-text-warning]");
        (e.setAttribute("aria-invalid", String(i)),
          r && ((r.hidden = !i), (r.textContent = message)),
          this.updatePersonalizationPreview(a));
      }
      (this.clearError(), this.renderSummary());
    }
    getRow(t) {
      return this.partyRows.find((e) => e.id === t);
    }
    addRow(t = null) {
      const e = this.makeRow(t);
      (this.partyRows.push(e),
        (this.activeId = e.id),
        this.render(),
        requestAnimationFrame(() =>
          this.querySelector(`[data-row-id="${e.id}"]`)
            ?.querySelector("select, input, button")
            ?.focus(),
        ));
    }
    optionAt(t, e) {
      return e < 0
        ? null
        : t.options
          ? t.options[e]
          : e === 0
            ? t.option1
            : e === 1
              ? t.option2
              : t.option3;
    }
    sizeOf(t) {
      return this.optionAt(t, this.sizeIndex);
    }
    colorOf(t) {
      return this.optionAt(t, this.colorIndex);
    }
    hasSizes() {
      return this.options.sizes.length > 0;
    }
    hasColors() {
      return this.options.colors.length > 0;
    }
    selectedVariant(t) {
      return this.variants.find(
        (e) =>
          (!this.hasSizes() || this.sizeOf(e) === t.size) &&
          (!this.hasColors() || this.colorOf(e) === t.color),
      );
    }
    isComplete(t) {
      const e = !t.personalize || (
        this.personalizationFields(t).every((key) => this.normalizedField(t, key)) &&
        t.approval?.status === "approved" &&
        t.approval.fingerprint === this.fingerprint(t)
      );
      return !!(
        (!this.hasSizes() || t.size) &&
        (!this.hasColors() || t.color) &&
        this.selectedVariant(t)?.available &&
        e
      );
    }
    cancelIncompletePersonalization(t) {
      const e = this.getRow(t);
      if (!e || !e.personalize || this.isComplete(e)) return !1;
      if (this.personalizationFields(e).some((key) => this.personalizationFieldValue(e, key).trim())) return !1;
      return (
        (e.personalize = !1),
        (e.frontText = ""),
        (e.frontInitial = ""),
        (e.bottomText = ""),
        (e.beltText = ""),
        (e.frontName = ""),
        (e.pocketInitials = ""),
        (e.abovePocketName = ""),
        (e.backText = ""),
        (this.personalizationEditorId = null),
        this.track("personalization_cancelled", { reason: "missing_required_text" }),
        this.render(),
        !0
      );
    }
    pricingFor(t) {
      const e = Number(this.selectedVariant(t)?.price || 0),
        a = this.personalization.mode === "live",
        s =
          t.personalize && a
            ? Number(this.personalizationChoice(t)?.price || this.personalization.prices?.[t.placement] || 0)
            : 0,
        i = e + s;
      return {
        baseUnitPrice: e,
        personalizationUnitPrice: s,
        unitTotal: i,
        quantity: t.quantity,
        finalTotal: i * t.quantity,
        pricingMode: this.personalization.mode || "preview",
      };
    }
    validationFor(t, requireApproval = true) {
      const fields = this.personalizationFields(t);
      const invalidField = t.personalize && fields.find((key) => this.fieldError(t, key));
      return !this.hasColors() || t.color
        ? !this.hasSizes() || t.size
          ? this.selectedVariant(t)?.available
            ? invalidField
              ? this.fieldError(t, invalidField)
              : requireApproval && t.personalize && (!t.approval || t.approval.status !== "approved" || t.approval.fingerprint !== this.fingerprint(t))
                  ? "Review and approve the personalization before adding it to cart."
                  : ""
            : "This size and shade combination is unavailable."
          : "Choose a size."
        : "Choose a shade.";
    }
    personalizationPreviewContent(t) {
      return this.activePreviewScenes(t).map(scene => {
        const overlays = scene.fields.map(field => { const d = field.definition, value = this.personalizationFieldValue(t, field.key).trim(), normalizedValue = field.key === "frontInitial" || field.key === "pocketInitials" ? value.toLocaleUpperCase("en-US") : value, sample = normalizedValue || (field.key === "frontInitial" || field.key === "pocketInitials" ? "B" : "Bride"), fontSize = Number(d.preferredFontSize || (field.key === "frontInitial" || field.key === "pocketInitials" ? 96 : 78)), minimumSize = Number(d.minimumFontSize || 30), maxLines = this.personalizationMaxLines(field.key), layout = this.wrappedTextLayout(sample, field.font, fontSize, minimumSize, Number(scene.dimensions.width) * Number(d.maxWidth || 60) / 100, maxLines), lines = layout.lines.map(line => `<span class="lsp__personalization-line">${this.escape(line)}</span>`).join(""); return `<strong class="lsp__personalization-overlay lsp__font-sample--${this.escape(field.font.toLowerCase())}" data-calibration-field="${this.escape(field.key)}" data-calibration-label="${this.escape(d.label || field.key)}" data-calibration-view="${this.escape(scene.key)}" data-calibration-font-size="${fontSize}" style="left:${Number(d.x || 50)}%;top:${Number(d.y || 30)}%;width:${Number(d.maxWidth || 60)}%;font-size:${layout.size / Number(scene.dimensions.width) * 100}cqw;line-height:1.15;--lsp-calibration-rotation:${Number(d.rotationDeg || 0)}deg">${lines}</strong>`; }).join("");
        return `<figure class="lsp__personalization-live-value ${scene.fields.every(field => !this.personalizationFieldValue(t, field.key).trim()) ? "is-empty" : ""}"><div class="lsp__personalization-scene" style="aspect-ratio:${scene.dimensions.width}/${scene.dimensions.height}"><img src="${this.escape(scene.image || "")}" alt="${this.escape(this.dataset.styleName)} ${scene.label.toLowerCase()} personalization view" width="${scene.dimensions.width}" height="${scene.dimensions.height}">${overlays}</div><figcaption>${scene.label} preview</figcaption></figure>`;
      }).join("");
    }
    personalizationPreviewHtml(t) {
      const fonts = [...new Set(this.activePreviewScenes(t).flatMap(scene => scene.fields.map(field => field.font)))].join(" / ");
      return `<div class="lsp__personalization-live-preview" data-personalization-live-preview><div class="lsp__personalization-live-heading"><strong>Your personalization preview</strong><span>${this.escape(fonts)}. Shown in black on white.</span></div><div class="lsp__personalization-live-values">${this.personalizationPreviewContent(t)}</div><p class="lsp__personalization-note"><strong>NOTE:</strong> Our designer will adjust the font size &amp; layout to fit the fabric in the best possible way. The delivered product personalization may be different from representation.</p></div>`;
    }
    updatePersonalizationPreview(t) {
      const e = this.querySelector(`[data-row-id="${t.id}"] [data-personalization-live-preview]`); if (!e) return;
      const a = e.querySelector(".lsp__personalization-live-values"); if (a) a.innerHTML = this.personalizationPreviewContent(t);
    }
    personalizationFontSelector(t, target) {
      const isFront = target === "front",
        font = isFront ? t.frontFont : t.backFont,
        allowed = isFront ? this.personalization.frontFonts : this.personalization.fonts,
        fontCatalog = [...new Map([...F, ...O].map((option) => [option.value, option])).values()],
        fonts = fontCatalog.filter(({ value }) => allowed.includes(value)),
        popup = `font-${target}`,
        open = this.openPopup === `${t.id}|${popup}`,
        label = t.placement === "Both" ? `${isFront ? "Front" : "Back"} Font` : "Select Font";
      return `<div class="lsp__swatches lsp__font-dropdown ${open ? "is-open" : ""}"><button type="button" class="lsp__swatch-toggle" data-popup-toggle="${popup}" aria-haspopup="dialog" aria-expanded="${open}"><p class="lsp__swatch-title">${label}:<span class="lsp__swatch-info"><span class="lsp__swatch-desc">${this.escape(font)}</span><svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4.29296 5.292L0.707479 1.70717C0.0774266 1.07723 0.523574 0 1.41452 0H8.58548C9.47643 0 9.92257 1.07723 9.29252 1.70717L5.70704 5.292C5.31653 5.68244 4.68347 5.68244 4.29296 5.292Z" fill="#67645E"></path></svg></span></p></button><div class="lsp__swatch-popup" data-popup="${popup}" role="dialog" aria-label="Choose the ${target} personalization font" ${open ? "" : "hidden"}><button type="button" class="lsp__swatch-popup-header" data-popup-close="${popup}" aria-label="Close ${target} font options">×</button><ul class="lsp__swatch-popup-group" role="presentation">${fonts.map(({ value, sample }) => `<li><button type="button" value="${value}" data-font-choice data-font-target="${target}" class="lsp__swatch-item ${font === value ? "is-selected" : ""}" aria-pressed="${font === value}"><span class="lsp__swatch-item-info"><span>${value}</span><b class="lsp__font-sample lsp__font-sample--${value.toLowerCase()}">${sample}</b></span></button></li>`).join("")}</ul></div><div class="lsp__swatch-popup-bg" data-popup-close="${popup}" ${open ? "" : "hidden"}></div></div>`;
    }
    formatMoney(t) {
      const e = (Number(t || 0) / 100).toFixed(2);
      return this.moneyFormat.includes("{{amount_no_decimals}}")
        ? this.moneyFormat.replace(
            "{{amount_no_decimals}}",
            String(Math.round(Number(t || 0) / 100)),
          )
        : this.moneyFormat.replace("{{amount}}", e);
    }
    personalizationEditorHtml(t, e, a, s, i) {
      const fields = this.personalizationFields(t),
        r = fields.some((field) => this.personalizationFieldDefinition(field).fontTarget !== "back"),
        c = fields.some((field) => this.personalizationFieldDefinition(field).fontTarget === "back"),
        reviewing = t.approval?.status === "review" && t.approval.fingerprint === this.fingerprint(t),
        steps = `<ol class="lsp__personalize-steps" aria-label="Personalization steps"><li class="${reviewing ? "is-done" : "is-current"}" ${reviewing ? "" : 'aria-current="step"'}><i aria-hidden="true">${reviewing ? "✓" : "1"}</i><span>Add details</span></li><li class="${reviewing ? "is-current" : ""}" ${reviewing ? 'aria-current="step"' : ""}><i aria-hidden="true">2</i><span>Review &amp; approve</span></li></ol>`;
      return `<dialog class="lsp__personalization-editor${reviewing ? " is-reviewing" : ""}" data-personalization-editor aria-labelledby="lsp-personalization-editor-title-${e}">
        <header class="lsp__personalization-editor-header">
          <div><h2 id="lsp-personalization-editor-title-${e}">Personalize</h2><p>A detail she will never forget</p></div>
          <button type="button" data-personalization-editor-close aria-label="Close personalization editor"><span>Close</span><b aria-hidden="true">×</b></button>
        </header>
        ${steps}
        <div class="lsp__personalization-editor-body">
          <section class="lsp__personalization-preview" aria-label="Personalization placement preview">
            ${this.personalizationPreviewHtml(t)}
            ${reviewing ? `<figure class="lsp__approval-proof"><img src="${t.approval.url}" alt="Final personalization proof"></figure>` : ""}
          </section>
          <section class="lsp__personalization-form" aria-label="Personalization details">
            <div class="lsp__personalize-title"><strong tabindex="-1" ${reviewing ? "" : "data-personalization-step-heading"}>Add Your Details</strong></div>
            <div class="lsp__placement-options" role="group" aria-label="Personalization placement">
              ${this.personalization.choices.map((choice) => { const y = Number(choice.price || 0), f = y > 0 ? ` (+${this.formatMoney(y).replace(/\.00\b/, "")})` : ""; return `<button type="button" value="${this.escape(choice.key)}" data-placement class="${t.placement === choice.key ? "is-selected" : ""}" aria-pressed="${t.placement === choice.key}"><i aria-hidden="true"></i><span>${this.escape(choice.label)}${f}</span></button>`; }).join("")}
            </div>
            <div class="lsp__personalize-section lsp__personalize-fonts">${this.personalization.sharedFont ? this.personalizationFontSelector(t, "front") : `${r ? this.personalizationFontSelector(t, "front") : ""}${c ? this.personalizationFontSelector(t, "back") : ""}`}</div>
            <div class="lsp__thread-section"><div class="lsp__swatches ${a ? "is-open" : ""}"><button type="button" class="lsp__swatch-toggle" data-popup-toggle="thread" aria-haspopup="dialog" aria-expanded="${a}"><p class="lsp__swatch-title">Font Color:<span class="lsp__swatch-info"><span class="lsp__swatch-desc">${this.escape(t.threadColor)}</span><svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4.29296 5.292L0.707479 1.70717C0.0774266 1.07723 0.523574 0 1.41452 0H8.58548C9.47643 0 9.92257 1.07723 9.29252 1.70717L5.70704 5.292C5.31653 5.68244 4.68347 5.68244 4.29296 5.292Z" fill="#67645E"></path></svg></span></p></button><div class="lsp__swatch-popup" data-popup="thread" role="dialog" aria-label="Choose a font colour" ${a ? "" : "hidden"}><button type="button" class="lsp__swatch-popup-header" data-popup-close="thread" aria-label="Close Font Colour Popup">×</button><ul class="lsp__swatch-popup-group" role="presentation">${i}</ul></div><div class="lsp__swatch-popup-bg" data-popup-close="thread" ${a ? "" : "hidden"}></div><div class="lsp__shade-rail" aria-label="Font colours">${s}</div></div></div>
            <div class="lsp__text-options">${fields.map((field) => this.personalizationTextField(t, field)).join("")}</div>
            <div class="lsp__approval-actions">${t.approval?.status === "review" && t.approval.fingerprint === this.fingerprint(t) ? `<div class="lsp__approval-review"><strong tabindex="-1" data-personalization-step-heading>Review your final personalization</strong><img class="lsp__approval-review-image" src="${t.approval.url}" alt="Final approved personalization proof"><p class="lsp__personalization-note"><strong>NOTE:</strong> Our designer will adjust the font size &amp; layout to fit the fabric in the best possible way. The delivered product personalization may be different from representation.</p><dl><div><dt>Style</dt><dd>${this.escape(t.approval.snapshot.style)}</dd></div><div><dt>Size and colour</dt><dd>${this.escape(`${t.size} · ${t.color}`)}</dd></div><div><dt>Lettering colour</dt><dd>${this.escape(t.threadColor)}</dd></div></dl><button type="button" data-personalization-approve>Approve personalization</button><button type="button" class="lsp__approval-edit" data-personalization-edit>Edit details</button></div>` : `<button type="button" data-personalization-review>Continue to review</button>`}</div>
          </section>
        </div>
      </dialog>`;
    }
    personalizationTextField(t, e) {
      const a = e === "frontInitial",
        s = this.personalizationFieldValue(t, e),
        definition = this.personalizationFieldDefinition(e),
        i = definition.label,
        r = Number(definition.limit),
        c = definition.placeholder,
        h = !s.trim(),
        o = `${t.id}-${e}-text-warning`;
      const dataAttribute = e === "frontInitial" ? "data-front-initial" : e === "bottomText" ? "data-bottom-text" : e === "beltText" ? "data-belt-text" : e === "frontName" ? "data-front-name" : e === "pocketInitials" ? "data-pocket-initials" : e === "abovePocketName" ? "data-above-pocket-name" : "data-back-text";
      const initial = e === "frontInitial" || e === "pocketInitials";
      return `<label><strong>${i} <span>(${r} ${r === 1 ? "Character" : "Characters"})</span><em>Required</em></strong><input ${dataAttribute} maxlength="${r}" data-maxlength="${r}" value="${this.escape(s)}" placeholder="${c}" aria-label="${i}" aria-required="true" aria-invalid="${h}" aria-describedby="${o}" required><span id="${o}" class="lsp__text-warning" data-text-warning ${h ? "" : "hidden"}>Enter ${initial ? "an initial" : "the personalization text"} to continue.</span></label>`;
    }
    rowHtml(t, e) {
      const a = this.isComplete(t),
        s = t.id === this.activeId || !a,
        i = t.id,
        r = this.options.sizes
          .map((o) => {
            const y = this.variants.some(
                (b) =>
                  this.sizeOf(b) === o &&
                  (!t.color || this.colorOf(b) === t.color) &&
                  b.available,
              ),
              f = t.color && !y,
              x = `${this.escape(o)}${f ? ", unavailable in selected shade" : ""}`,
              P =
                this.variants.find(
                  (b) =>
                    this.sizeOf(b) === o &&
                    (!t.color || this.colorOf(b) === t.color),
                ) || this.variants.find((b) => this.sizeOf(b) === o),
              _ = Number(P?.price || 0),
              L = _ > 0 ? this.formatMoney(_).replace(/\.00\b/, "") : "";
            return `<li><label class="lsp__size-option ${t.size === o ? "is-selected" : ""} ${f ? "is-unavailable" : ""}"><input type="radio" name="${i}-size" value="${this.escape(o)}" data-size ${t.size === o ? "checked" : ""} ${f ? "disabled" : ""} aria-label="${x}${_ > 0 ? `, ${this.formatMoney(_)}` : ""}"><strong>${this.escape(o)}</strong>${L ? `<span>${L}</span>` : ""}</label></li>`;
          })
          .join(""),
        c = this.options.colors.map((o) => {
          const connectedShade = this.connectedShades[o],
            y = connectedShade
              ? connectedShade.available
              : this.variants.some(
                  (B) =>
                    (!t.size || this.sizeOf(B) === t.size) &&
                    this.colorOf(B) === o &&
                    B.available,
                ),
            f = t.size && !y,
            x = S[o] || "#ded3c7",
            P = I(o),
            _ = this.shadeImages[o],
            L = _
              ? `<img src="${this.escape(_)}" alt="" loading="lazy">`
              : this.satinTexture
                ? `<span class="lsp__shade-fabric" style="--lsp-fabric:url('${this.escape(this.satinTexture)}')" aria-hidden="true"></span>`
                : '<span class="lsp__shade-fallback" aria-hidden="true"></span>',
            b = String(this.options.colors.indexOf(o) + 1).padStart(2, "0"),
            T = `${this.escape(o)}${f ? ", unavailable in selected size" : ""}`;
          return {
            swatch: `<label class="lsp__shade ${P ? "is-light" : ""} ${t.color === o ? "is-selected" : ""} ${f ? "is-unavailable" : ""}" style="--lsp-swatch:${x}" title="${this.escape(o)}${f ? ", unavailable in selected size" : ""}"><input type="radio" name="${i}-color" value="${this.escape(o)}" data-color ${t.color === o ? "checked" : ""} ${f ? "disabled" : ""} aria-label="${T}"><span class="lsp__shade-image">${L}</span><b>${this.escape(o)}</b></label>`,
            item: `<li><label class="lsp__swatch-item ${t.color === o ? "is-selected" : ""} ${f ? "is-unavailable" : ""}" style="--lsp-swatch:${x}"><input type="radio" name="${i}-color-popup" value="${this.escape(o)}" data-color ${t.color === o ? "checked" : ""} ${f ? "disabled" : ""} aria-label="${T}"><span class="lsp__swatch-item-image">${L}</span><span class="lsp__swatch-item-info"><b>${b}</b><b>-</b><span>${this.escape(o)}</span></span></label></li>`,
          };
        }),
        h = c.map((o) => o.swatch).join(""),
        p = c.map((o) => o.item).join(""),
        d = t.color
          ? String(this.options.colors.indexOf(t.color) + 1).padStart(2, "0")
          : "",
        n = this.openPopup === `${t.id}|shade`,
        m = this.openPopup === `${t.id}|thread`,
        w = Object.entries(T).filter(([name]) => this.personalization.threadColors.includes(name)),
        l = (o) => {
          const y = this.threadImages[o];
          return y ? `<img src="${this.escape(y)}" alt="" loading="lazy">` : "";
        },
        u = w
          .map(
            ([o, y]) =>
              `<button type="button" value="${o}" data-thread-color class="lsp__shade ${t.threadColor === o ? "is-selected" : ""}" aria-pressed="${t.threadColor === o}" style="--lsp-swatch:${y}" title="${o}"><span class="lsp__shade-image">${l(o)}</span><b>${o}</b>${o === "Metallic Gold" ? '<small class="lsp__thread-hot">HOT!</small>' : ""}</button>`,
          )
          .join(""),
        k = w
          .map(
            ([o, y]) =>
              `<li><button type="button" value="${o}" data-thread-color class="lsp__swatch-item ${t.threadColor === o ? "is-selected" : ""}" aria-pressed="${t.threadColor === o}" style="--lsp-swatch:${y}"><span class="lsp__swatch-item-image">${l(o)}</span><span class="lsp__swatch-item-info"><span>${o}</span>${o === "Metallic Gold" ? '<small class="lsp__thread-hot">HOT!</small>' : ""}</span></button></li>`,
          )
          .join(""),
        F = `Set ${e + 1}`,
        O = a
          ? `${t.quantity > 1 ? `${t.quantity} sets · ` : ""}${this.escape(t.size)} · ${this.escape(t.color)}${t.personalize ? " · Personalized" : ""}`
          : "Finish this set",
        z = this.pricingFor(t),
        q = this.validationFor(t);
      return `<article class="lsp__row ${s ? "is-open" : "is-complete"}" data-row-id="${i}">
        <header class="lsp__row-header">
          <div><span class="lsp__row-number">${String(e + 1).padStart(2, "0")}</span><strong>${F}</strong><small>${O}</small></div>
          <div class="lsp__row-header-actions">
            ${a && !s ? '<button type="button" class="lsp__text-button" data-row-action="edit">Edit</button>' : ""}
            ${this.partyRows.length > 1 ? '<button type="button" class="lsp__icon-button" data-row-action="remove" aria-label="Remove this set">×</button>' : ""}
          </div>
        </header>
        ${
          s
            ? `<div class="lsp__row-body">
          ${
            this.hasColors()
              ? `<fieldset class="lsp__fieldset lsp__fieldset--shade"><legend class="lsp__sr-only">Shade</legend><div class="lsp__swatches ${n ? "is-open" : ""}">
            <button type="button" class="lsp__swatch-toggle" data-popup-toggle="shade" aria-haspopup="dialog" aria-expanded="${n}"><p class="lsp__swatch-title">${this.escape(this.colorName)}:<span class="lsp__swatch-info">${t.color ? `<b>${d}&nbsp;-&nbsp;</b><span class="lsp__swatch-desc">${this.escape(t.color)}</span>` : '<span class="lsp__swatch-desc">Select a shade</span>'}<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M4.29296 5.292L0.707479 1.70717C0.0774266 1.07723 0.523574 0 1.41452 0H8.58548C9.47643 0 9.92257 1.07723 9.29252 1.70717L5.70704 5.292C5.31653 5.68244 4.68347 5.68244 4.29296 5.292Z" fill="#67645E"></path></svg></span></p></button>
            <div class="lsp__swatch-popup" data-popup="shade" role="dialog" aria-label="Choose a shade" ${n ? "" : "hidden"}><button type="button" class="lsp__swatch-popup-header" data-popup-close="shade" aria-label="Close Swatches Popup"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><circle cx="9" cy="9" r="9" transform="rotate(90 9 9)" fill="#67645E"></circle><path d="M13.0015 8.99957L5.00147 8.99957" stroke="white"></path></svg></button><ul class="lsp__swatch-popup-group" role="presentation">${p}</ul></div>
            <div class="lsp__swatch-popup-bg" data-popup-close="shade" ${n ? "" : "hidden"}></div>
            <div class="lsp__shade-rail" aria-label="Available pajama shades">${h}</div>
          </div>${!t.color && this.invalidId === t.id ? `<p class="lsp__field-error">${q}</p>` : ""}</fieldset>`
              : ""
          }
          <div class="lsp__selection-controls">
          ${
            this.hasSizes()
              ? `<fieldset class="lsp__fieldset lsp__fieldset--size"><legend class="lsp__sr-only">Select ${this.escape(this.sizeName)}</legend><div class="lsp__size-heading"><div class="lsp__size-current"><span>${this.escape(this.sizeName)}:</span><strong>${t.size ? this.escape(t.size) : `Select ${this.sizeName.toLowerCase()}`}</strong></div><button type="button" class="lsp__size-guide-link" data-size-guide-open>Size Guide</button></div><div class="lsp__size-options-window" data-size-options-window><ul class="lsp__size-options" data-size-options role="presentation">${r}</ul></div>${t.color && !t.size && this.invalidId === t.id ? `<p class="lsp__field-error">${q}</p>` : ""}</fieldset>`
              : ""
          }
          <div class="lsp__quantity"><div class="lsp__quantity-heading"><span class="lsp__quantity-badge"><span class="lsp__quantity-badge-icon" aria-hidden="true">◆</span>Extra 5% off on 5+ items</span></div><div class="lsp__quantity-shell" role="group" aria-label="Quantity"><button type="button" data-quantity-action="decrease" aria-label="Decrease quantity" ${t.quantity <= 1 ? "disabled" : ""}>−</button><output aria-live="polite" aria-label="Current quantity">${t.quantity}</output><button type="button" data-quantity-action="increase" aria-label="Increase quantity" ${t.quantity >= 10 ? "disabled" : ""}>+</button></div></div>
          </div>
${
  this.personalization.enabled === !1
    ? ""
    : `          <div class="lsp__personalize-block">
          <div class="lsp__personalization-actions">
          <div class="lsp__personalize-control">
            <svg class="lsp__sparkles" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9.8132 15.9038L9 18.75L8.1868 15.9038C7.75968 14.4089 6.59112 13.2403 5.09619 12.8132L2.25 12L5.09619 11.1868C6.59113 10.7597 7.75968 9.59112 8.1868 8.09619L9 5.25L9.8132 8.09619C10.2403 9.59113 11.4089 10.7597 12.9038 11.1868L15.75 12L12.9038 12.8132C11.4089 13.2403 10.2403 14.4089 9.8132 15.9038Z"/><path d="M18.2589 8.71454L18 9.75L17.7411 8.71454C17.4388 7.50533 16.4947 6.56117 15.2855 6.25887L14.25 6L15.2855 5.74113C16.4947 5.43883 17.4388 4.49467 17.7411 3.28546L18 2.25L18.2589 3.28546C18.5612 4.49467 19.5053 5.43883 20.7145 5.74113L21.75 6L20.7145 6.25887C19.5053 6.56117 18.5612 7.50533 18.2589 8.71454Z"/><path d="M16.8942 20.5673L16.5 21.75L16.1058 20.5673C15.8818 19.8954 15.3546 19.3682 14.6827 19.1442L13.5 18.75L14.6827 18.3558C15.3546 18.1318 15.8818 17.6046 16.1058 16.9327L16.5 15.75L16.8942 16.9327C17.1182 17.6046 17.6454 18.1318 18.3173 18.3558L19.5 18.75L18.3173 19.1442C17.6454 19.3682 17.1182 19.8954 16.8942 20.5673Z"/></svg>
            <strong>Personalize</strong>
            <label class="lsp__toggle">
              <input type="checkbox" data-personalize ${t.personalize ? "checked" : ""} aria-label="Personalize this pajama set">
              <span class="lsp__switch-track" aria-hidden="true"><i><em></em></i></span>
            </label>
          </div>
          ${
            t.personalize
              ? `<div class="lsp__personalization-summary"><button type="button" data-personalization-editor-open>${t.approval?.status === "approved" && t.approval.fingerprint === this.fingerprint(t) ? "Approved · Edit personalization" : "Needs approval · Edit personalization"} <span aria-hidden="true">→</span></button></div>`
              : ""
          }
          </div>
          ${t.personalize ? `<div class="lsp__pricing" aria-live="polite"><div><span>Base set</span><strong>${z.baseUnitPrice ? this.formatMoney(z.baseUnitPrice) : "Select options"}</strong></div><div><span>${this.escape(this.personalizationChoice(t)?.label || t.placement)} personalization</span><strong>${z.personalizationUnitPrice > 0 ? `+${this.formatMoney(z.personalizationUnitPrice)}` : "Included"}</strong></div><div><span>Quantity</span><strong>${z.quantity}</strong></div><div class="lsp__pricing-total"><span>Final price</span><strong>${this.formatMoney(z.finalTotal)}</strong></div></div>${this.personalizationEditorHtml(t, i, m, u, k)}` : ""}
          ${t.personalize && this.invalidId === t.id && q ? `<p class="lsp__field-error">${q}</p>` : ""}
          </div>`
}
        </div>`
            : ""
        }
      </article>`;
    }
    render(t = {}) {
      (this.partyRows.some((a) => a.id === this.activeId) ||
        (this.activeId = this.partyRows[0]?.id),
        (this.rowsHost.innerHTML = this.partyRows
          .map((a, s) => this.rowHtml(a, s))
          .join("")),
        this.renderSummary(),
        this.setupSizeOverflowHints());
      if (this.personalizationEditorId) {
        const a = this.querySelector(
          `[data-row-id="${this.personalizationEditorId}"] [data-personalization-editor]`,
        );
        a?.showModal();
      }
      if (t.preserveFocus) {
        const a = this.querySelector(
          `[data-row-id="${this.activeId}"] [data-${t.preserveFocus}]`,
        );
        a && (a.focus(), a.setSelectionRange?.(t.cursor, t.cursor));
      }
    }
    setupSizeOverflowHints() {
      this.querySelectorAll("[data-size-options]").forEach((rail) => {
        const windowElement = rail.closest("[data-size-options-window]");
        if (!windowElement) return;
        const update = () => {
          const hasOverflow = rail.scrollWidth > rail.clientWidth + 2;
          const isAtEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
          windowElement.classList.toggle("has-overflow", hasOverflow);
          windowElement.classList.toggle("is-scroll-end", !hasOverflow || isAtEnd);
        };
        rail.addEventListener("scroll", update, { passive: true });
        requestAnimationFrame(() => {
          update();
          const options = [...rail.querySelectorAll(".lsp__size-option")],
            selectedIndex = options.findIndex((option) =>
              option.classList.contains("is-selected"),
            );
          if (
            rail.scrollWidth > rail.clientWidth + 2 &&
            selectedIndex >= options.length - 2
          ) {
            rail.scrollTo({
              left: rail.scrollWidth - rail.clientWidth,
              behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
                .matches
                ? "auto"
                : "smooth",
            });
          }
        });
      });
    }
    revealSelectedShade(t) {
      const e = this.querySelector(
          `[data-row-id="${t}"] .lsp__shade.is-selected`,
        ),
        a = e?.closest(".lsp__shade-rail");
      if (!e || !a) return;
      e.querySelector("input")?.focus({ preventScroll: !0 });
      const s = 4,
        i = e.offsetLeft - s,
        r = e.offsetLeft + e.offsetWidth + s;
      i < a.scrollLeft
        ? (a.scrollLeft = i)
        : r > a.scrollLeft + a.clientWidth &&
          (a.scrollLeft = r - a.clientWidth);
    }
    renderSummary() {
      const t = this.partyRows.filter((c) => this.isComplete(c)),
        e = this.partyRows.length - t.length,
        a = this.partyRows.reduce((c, h) => c + h.quantity, 0),
        s = t.reduce((c, h) => c + h.quantity, 0),
        i = t.reduce((c, h) => c + this.pricingFor(h).finalTotal, 0),
        r = e === 0 && this.partyRows.length > 0;
      ((this.addButton.disabled = !r),
        (this.stickyButton.disabled = !r),
        this.selectedPrice &&
          (this.selectedPrice.textContent = this.formatMoney(
            Number(this.selectedVariant(this.partyRows[0])?.price || 0),
          ).replace(/\.00\b/, "")),
        this.selectedComparePrice &&
          ((this.selectedComparePrice.textContent = this.formatMoney(
            Number(this.selectedVariant(this.partyRows[0])?.compare_at_price || 0),
          ).replace(/\.00\b/, "")),
          (this.selectedComparePrice.hidden = Number(this.selectedVariant(this.partyRows[0])?.compare_at_price || 0) <= Number(this.selectedVariant(this.partyRows[0])?.price || 0))),
        this.syncStickyControls(),
        (this.addLabel.innerHTML = r
          ? `<span class="lsp__primary-text">${this.bagEdit ? "Save changes" : "Add To Cart"}</span><span class="lsp__primary-sep">|</span><span class="lsp__primary-price">${this.formatMoney(i)}</span>`
          : `<span class="lsp__primary-text">${this.bagEdit ? "Save changes" : "Add To Cart"}</span>`),
        (this.stickyButton.textContent = r
          ? `${this.bagEdit ? "Save changes" : "Add to cart"} · ${this.formatMoney(i)}`
          : "Add to cart"));
    }
    syncStickyControls() {
      const t = this.partyRows[0];
      if (t) {
        if (this.stickyColor) {
          (Array.from(this.stickyColor.options).forEach((i) => {
            i.value &&
              (i.disabled = t.size
                ? !this.variants.some(
                    (r) =>
                      r.available &&
                      this.sizeOf(r) === t.size &&
                      this.colorOf(r) === i.value,
                  )
                : !this.variants.some(
                    (r) => r.available && this.colorOf(r) === i.value,
                  ));
          }),
            (this.stickyColor.value = t.color || ""));
          const e = this.querySelector("[data-sticky-color-trigger]"),
            a = this.querySelector("[data-sticky-color-swatch]"),
            s = this.querySelector("[data-sticky-color-value]");
          (s && (s.textContent = t.color || "Choose shade"),
            (a.hidden = !t.color),
            t.color && ((a.style.backgroundColor = S[t.color] || ""), (a.style.backgroundImage = this.shadeImages[t.color] ? `url("${this.shadeImages[t.color]}")` : ""), (a.style.backgroundSize = "cover")),
            this.querySelectorAll("[data-sticky-color-choice]").forEach((i) => {
              const r = Array.from(this.stickyColor.options).find(
                (c) => c.value === i.dataset.stickyColorChoice,
              );
              ((i.disabled = !!r?.disabled),
                i.setAttribute(
                  "aria-selected",
                  String(i.dataset.stickyColorChoice === t.color),
                ));
            }),
            e.getAttribute("aria-expanded") !== "true" &&
              (this.querySelector("[data-sticky-color-menu]").hidden = !0));
        }
        if (this.stickySize) {
          (Array.from(this.stickySize.options).forEach((s) => {
            s.value &&
              (s.disabled = t.color
                ? !this.variants.some(
                    (i) =>
                      i.available &&
                      this.sizeOf(i) === s.value &&
                      this.colorOf(i) === t.color,
                  )
                : !this.variants.some(
                    (i) => i.available && this.sizeOf(i) === s.value,
                  ));
          }),
            (this.stickySize.value = t.size || ""));
          const e = this.querySelector("[data-sticky-size-value]");
          (e && (e.textContent = t.size || "Choose size"),
            this.querySelectorAll("[data-sticky-size-choice]").forEach((s) => {
              const i = Array.from(this.stickySize.options).find(
                (r) => r.value === s.dataset.stickySizeChoice,
              );
              ((s.disabled = !!i?.disabled),
                s.setAttribute(
                  "aria-selected",
                  String(s.dataset.stickySizeChoice === t.size),
                ));
            }));
          const a = this.querySelector("[data-sticky-size-trigger]");
          if (a && a.getAttribute("aria-expanded") !== "true") {
            const s = this.querySelector("[data-sticky-size-menu]");
            s && (s.hidden = !0);
          }
        }
      }
    }
    validate() {
      const t = this.partyRows.find((e) => !this.isComplete(e));
      return t
        ? ((this.activeId = t.id),
          (this.invalidId = t.id),
          this.render(),
          this.showError(this.validationFor(t)),
          this.track("builder_validation_error", {
            category: this.validationFor(t),
          }),
          requestAnimationFrame(() =>
            this.querySelector(`[data-row-id="${t.id}"]`)?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            }),
          ),
          !1)
        : !0;
    }
    async addToCart() {
      if (this.bagEdit && (this.partyRows.length !== 1 || !this.partyRows[0].personalize)) {
        this.showError("Keep one personalized item while editing. To remove personalization, remove the item from your bag and add it without personalization.");
        return;
      }
      if (!this.validate()) return;
      this.track("add_to_cart_attempt", { quantity: this.partyRows.reduce((total, row) => total + row.quantity, 0), pricing_mode: this.personalization.mode });
      this.setLoading(true); this.clearError();
      let batch = null;
      try {
        const cartApi = window.BlossomPersonalizationCart;
        if (!cartApi?.addPersonalizedPair) throw new Error("Personalization checkout is still loading. Please retry.");
        batch = crypto.randomUUID(); let latestResponse = null;
        for (const row of this.partyRows) {
          const variant = this.selectedVariant(row);
          if (!row.personalize) {
            const response = await fetch(window.routes?.cart_add_url || "/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: variant.id, quantity: row.quantity }], sections: "cart-drawer", sections_url: location.pathname }) });
            latestResponse = await response.json(); if (!response.ok) throw new Error(latestResponse.description || "The item could not be added."); continue;
          }
          const approval = row.approval, choice = this.personalizationChoice(row), feeVariant = Number(choice.variantId), group = crypto.randomUUID();
          if (!approval || approval.status !== "approved" || approval.fingerprint !== this.fingerprint(row)) throw new Error("Review and approve every personalization before adding it to cart.");
          if (!feeVariant) throw new Error(`${choice.label} personalization fee is not configured.`);
          const proofHash = Array.from(new Uint8Array(await crypto.subtle.digest("SHA-256", await approval.blob.arrayBuffer()))).map(value => value.toString(16).padStart(2, "0")).join("");
          const fields = this.personalizationFields(row), properties = {
            Style: this.dataset.styleName, Personalization: "Yes", Placement: choice.label,
            ...Object.fromEntries(fields.map(key => [this.personalizationFieldDefinition(key).label, this.normalizedField(row, key)])),
            ...Object.fromEntries(fields.map(key => [`${this.personalizationFieldDefinition(key).label.replace(/ text$/i, "")} font`, this.personalizationFieldDefinition(key).fontTarget === "back" ? row.backFont : row.frontFont])),
            "Font color": row.threadColor, "Personalization price": this.formatMoney(Number(choice.price || 0)),
            "_Personalization schema": "1", "_Personalization group": group, "_Personalization profile": this.personalization.profile,
            "_Personalization choice": row.placement, "_Personalization proof": approval.proofId, "_Personalization version": String(this.personalization.version || 1),
            "_Personalization approved at": approval.approvedAt, "_Personalization fingerprint": approval.fingerprint,
            "_Personalization proof hash": proofHash, "_Personalization add-on variant": String(feeVariant), "_Personalization fee units": "1", "_Personalization batch": batch,
          };
          latestResponse = await cartApi.addPersonalizedPair({
            group,
            garment: { variantId: variant.id, quantity: row.quantity, properties, proofBlob: approval.blob, proofId: approval.proofId },
            fee: { variantId: feeVariant, quantity: row.quantity, properties: { "_Personalization fee": "true", "_Personalization group": group, "_Associated garment": String(variant.id), "_Personalization fee key": `${this.personalization.profile}_${row.placement.toLowerCase()}`, "_Personalization batch": batch } }
          });
        }
        if (this.bagEdit) {
          latestResponse = await window.bagCompleteEdit(this, batch) || latestResponse;
          batch = null;
        }
        window.eventBus?.emit("update:cart:drawer", latestResponse);
        window.eventBus?.emit("open:cart:drawer", { scrollToTop: true });
        requestAnimationFrame(() => {
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer?.isConnected && cartDrawer.getAttribute("aria-hidden") !== "false") cartDrawer.openDrawer?.();
        });
        window.eventBus?.emit("cart:added", { sectionId: this.dataset.sectionId });
        this.addLabel.textContent = "Added to cart"; this.track("add_to_cart_success", { quantity: this.partyRows.reduce((total, row) => total + row.quantity, 0) });
      } catch (error) {
        if (batch && !error.bagEditUncertain && window.BlossomPersonalizationCart?.removeBatch) {
          try { await window.BlossomPersonalizationCart.removeBatch(batch); } catch (_) { /* retain the original actionable error */ }
        }
        this.showError(error.message || "We could not add this group to the cart. Please try again."); this.track("add_to_cart_error", { category: error.message || "unknown" });
      }
      finally { this.setLoading(false); this.renderSummary(); }
    }
    setLoading(t) {
      (this.addButton.classList.toggle("is-loading", t),
        (this.addButton.disabled = t),
        this.addButton.setAttribute("aria-busy", String(t)));
    }
    setupSticky() {
      const t = () => {
        // Show the shortcut only after the purchase controls have left the viewport.
        const e = this.addButton.getBoundingClientRect().bottom <= 0;
        this.sticky.inert = !e;
        (this.sticky.setAttribute("aria-hidden", String(!e)),
          this.sticky.classList.toggle("is-visible", e));
      };
      (window.addEventListener("scroll", t, { passive: !0 }),
        window.addEventListener("resize", t, { passive: !0 }),
        t());
    }
    handleStickyAction() {
      this.partyRows.every((t) => this.isComplete(t))
        ? this.addToCart()
        : this.validate();
    }
    setGallery(t) {
      const e = this.querySelector("[data-gallery-image]");
      (t.dataset.srcset
        ? (e.srcset = t.dataset.srcset)
        : e.removeAttribute("srcset"),
        (e.src = t.dataset.src),
        (e.alt = t.dataset.alt),
        this.querySelectorAll("[data-gallery-thumb]").forEach((s) => {
          const i = s === t;
          (s.classList.toggle("is-active", i),
            s.setAttribute("aria-pressed", String(i)));
        }));
      const a = this.querySelector("[data-gallery]");
      ((this.querySelector("[data-gallery-count]").textContent =
        `${t.dataset.index} / ${a?.dataset.galleryTotal || this.querySelectorAll("[data-gallery-thumb]").length}`),
        this.track("gallery_interaction", { index: Number(t.dataset.index) }));
    }

    // The palette studio lives in its own section now, so it asks for a shade by
    // event rather than reaching into this element's DOM.
    setupShadeRequests() {
      document.addEventListener("lsp:apply-shade", (event) => {
        const color = event.detail?.color;
        if (!color) return;
        const row = this.partyRows[0];
        const available = this.variants.some(
          (v) =>
            this.colorOf(v) === color &&
            (!row.size || this.sizeOf(v) === row.size) &&
            v.available,
        );
        const reply = (ok, message) =>
          document.dispatchEvent(
            new CustomEvent("lsp:apply-shade-result", {
              detail: { color, applied: ok, message },
            }),
          );
        if (!available) {
          reply(
            false,
            row.size
              ? `${color} is unavailable in ${row.size}. Choose another size or palette shade.`
              : `${color} is currently unavailable.`,
          );
          return;
        }
        ((row.color = color), this.clearError(), this.render());
        reply(true, `${color} has been applied to your pajama set.`);
        this.track("palette_shade_applied", { shade: color });
      });
    }
    track(t, e = {}) {
      const a = { event: `pajama_${t}`, ...e };
      (window.dataLayer?.push(a),
        window.dispatchEvent(
          new CustomEvent("pajama:analytics", { detail: a }),
        ));
    }
    showError(t) {
      const dialog = this.querySelector("[data-personalization-editor][open]");
      if (dialog) {
        let message = dialog.querySelector("[data-personalization-error]");
        if (!message) {
          message = document.createElement("p");
          message.dataset.personalizationError = "";
          message.className = "lsp__field-error";
          message.setAttribute("role", "alert");
          dialog.querySelector(".lsp__approval-actions")?.prepend(message);
        }
        message.textContent = t;
      }
      ((this.error.textContent = t), (this.error.hidden = !1));
    }
    clearError() {
      this.querySelectorAll("[data-personalization-error]").forEach(message => message.remove());
      ((this.invalidId = null),
        (this.error.textContent = ""),
        (this.error.hidden = !0));
    }
    escape(t = "") {
      const e = document.createElement("div");
      return (
        (e.textContent = String(t)),
        e.innerHTML.replace(/"/g, "&quot;").replace(/'/g, "&#39;")
      );
    }
  }
  customElements.get("apex-pj-builder") ||
    customElements.define("apex-pj-builder", M);
})();
